// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5LPrA","content":"styles_content__1raUE","row":"styles_row__3JHq0","footer":"styles_footer__2S4o_","phraseLength":"styles_phraseLength__1-yld"};